enum SidebarAction {
  SET_SELECTED = '[sidebar] Set selected content',
  SET_MINIMIZED = '[sidebar] Set minimized',
  SET_LONG = '[sidebar] Set long'
}

export default SidebarAction
